import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import SectionHero from '../../Helpers/SectionHero';
import SectionCTA from '../../Helpers/SectionCTA';
import ServiceCard from '../../Helpers/ServiceCard';
import FaqItem from '../../Helpers/FaqItem';
import softwareDev from '../../../assets/images/services/software_dev.jpg';
import { useLanguage } from '../../../i18n/LanguageContext';

const serviceIcons = ['fa-database', 'fa-layer-group', 'fa-gears', 'fa-chart-line', 'fa-shield-halved'];
const resultIcons = ['fa-coins', 'fa-bolt', 'fa-cubes-stacked'];

const SoftwareConsulting = () => {
  const { t } = useLanguage();
  const servicios = t('software.servicios').map((s, i) => ({ ...s, icon: serviceIcons[i] }));
  const resultados = t('software.resultados').map((r, i) => ({ ...r, icon: resultIcons[i] }));
  const faqs = t('software.faqs');

  return (
    <>
      {/* Hero */}
      <SectionHero badge={t('nav.tecnologia')} title={t('software.title')} image={softwareDev} imagePos="center">
        <p className="text-blue-100 text-lg md:text-xl">
          {t('software.subtitle')}
        </p>
      </SectionHero>

      {/* Servicios — fondo claro, lenguaje visual alineado al inicio */}
      <section
        className="relative overflow-hidden py-24"
        style={{ background: 'linear-gradient(180deg, #f8fafc 0%, #eef3f8 100%)' }}
      >
        <div
          className="dot-grid pointer-events-none absolute top-10 right-8 w-44 h-32 opacity-60 hidden md:block"
          style={{ maskImage: 'linear-gradient(225deg, #000, transparent 75%)', WebkitMaskImage: 'linear-gradient(225deg, #000, transparent 75%)' }}
        ></div>
        <div className="contain relative z-10">
          <div className="text-center max-w-2xl mx-auto mb-16" data-aos="fade-up">
            <h2 className="text-4xl font-bold text-salient-primary mb-4">{t('software.serviciosTitle')}</h2>
            <div className="w-24 h-1.5 bg-salient-green mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
            {servicios.map((item, index) => (
              <ServiceCard
                key={index}
                index={index}
                icon={item.icon}
                title={item.title}
                text={item.description}
                delay={(index % 3) * 100}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Resultados esperados */}
      <section className="bg-white py-24">
        <div className="contain">
          <div className="text-center max-w-2xl mx-auto mb-16" data-aos="fade-up">
            <h2 className="text-4xl font-bold text-salient-primary mb-4">{t('software.resultadosTitle')}</h2>
            <div className="w-24 h-1.5 bg-salient-green mx-auto rounded-full"></div>
            <p className="mt-4 text-gray-600">{t('software.resultadosSubtitle')}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">
            {resultados.map((item, index) => (
              <ServiceCard
                key={index}
                index={index}
                icon={item.icon}
                title={item.title}
                text={item.description}
                delay={index * 100}
              />
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-gray-50 py-24">
        <div className="contain max-w-3xl">
          <div className="text-center mb-12" data-aos="fade-up">
            <h2 className="text-4xl font-bold text-salient-primary mb-4">{t('software.faqTitle')}</h2>
            <div className="w-24 h-1.5 bg-salient-green mx-auto rounded-full"></div>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <FaqItem key={index} q={faq.q} a={faq.a} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <SectionCTA
        title={t('software.ctaTitle')}
        text={t('software.ctaText')}
      />
    </>
  );
};

export default SoftwareConsulting;
